import { Weapon } from "./weaponPickup";
import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Bullets } from "./bullets";
import * as bulletData from "./bulletData.json";
import { Waves } from "./waves"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference

export class Weapons {
	self: Phaser.Physics.Arcade.Group;
	closestWeapon: Weapon | null;
	lastShotTime = 0;

	allowedWeapons: string[] = ["mg", "shotty", "minigun", "flamethrower", "rocket", "mine"];

	openSound: Phaser.Sound.BaseSound;

	constructor() // world: Phaser.Physics.Arcade.World,
	// scene: Phaser.Scene
	{
		// super(world, scene, {
		// 	classType: Zombie,
		// 	runChildUpdate: true,
		// });
	}

	preload(scene: Phaser.Scene): void {
		// load bullet sprites here
		// scene.load.image("gun", "assets/gun.png");

		// SOUND!
		scene.load.audio("pickup", ["release_assets/sound/pickup.wav"]);
	}

	create(scene: Phaser.Scene, map: Maps, waves: Waves): void {
		// looks like we need a new "bullet(singular)" class for each different type of bullet!
		this.self = scene.physics.add.group({
			classType: Weapon,
			runChildUpdate: true
		});
		const spawnPoints: TiledObject[] = map.self.filterObjects(
			"Events",
			(obj: Phaser.GameObjects.GameObject): boolean => {
				return obj.name === "Weapon Spawn";
			}
		);
		for (const spawnPoint of spawnPoints) {
			const json: { [index: string]: BulletJSON } = bulletData;
			// Get a random weapon from our list...
			const whichGun: number = Phaser.Math.RND.between(0, this.allowedWeapons.length - 1);
			const price: number = json[this.allowedWeapons[whichGun]].price;
			const name: string = this.allowedWeapons[whichGun];

			const weapon: Weapon = this.self.get(-100, -100) as Weapon;
			weapon.create(spawnPoint.x, spawnPoint.y, price, spawnPoint.type, name);
		}
		const spawnPoint: TiledObject =
			spawnPoints[Phaser.Math.RND.between(0, spawnPoints.length - 1)];

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.2
		};

		this.openSound = scene.sound.add("pickup", config);
	}

	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite,
		ammo: Bullets,
		waves: Waves
	): void {
		this.closestWeapon = null;
		for (const child of this.self.getChildren() as Weapon[]) {
			if (Phaser.Math.Distance.Between(child.x, child.y, player.x, player.y) <= 50) {
				if (child.spent >= child.cost) {
					// Play a door opening sound as proof of concept...
					this.openSound.play();

					ammo.getNewWeapon(child.gunType);
					child.spent = 0;
					const waveNum: number = waves.getCurrentWaveNumber();
					child.cost = Math.floor(child.cost + (child.cost * waveNum * 0.05));
				} else {
					this.closestWeapon = child;
					child.showCost();
				}
			} else {
				child.hideCost();
			}
		}
	}
	afford(money: number): boolean {
		if (this.closestWeapon) {
			if (money >= this.closestWeapon.cost) {
				return true;
			}
		}
		return false;
	}

	buy(waves: Waves): number {
		if (this.closestWeapon) {
			this.closestWeapon.spent = this.closestWeapon.cost;
			return this.closestWeapon.cost;
		}
		return 0;
	}
}
